export default "/images/framework/WordMissionCht.729b3bfd.svg?729b3bfd";